/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginResponse } from '../models/LoginResponse';
import type { RegisterRequest } from '../models/RegisterRequest';
import type { WhoAmIResponse } from '../models/WhoAmIResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuthApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Log in
   * @param requestBody Login body schema
   * @returns LoginResponse Success login response
   * @throws ApiError
   */
  public login(
    requestBody?: {
      email: string;
      password: string;
    },
  ): CancelablePromise<LoginResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        403: `Forbidden`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Log in
   * @param requestBody Login body schema
   * @returns LoginResponse Success login response
   * @throws ApiError
   */
  public loginWarehouse(
    requestBody?: {
      email: string;
      password: string;
    },
  ): CancelablePromise<LoginResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/warehouse/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        403: `Forbidden`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Logout
   * @returns any Successfully logged out
   * @throws ApiError
   */
  public postAuthLogout(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/logout',
      errors: {
        401: `Unauthorized`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Check is user logged in
   * @returns WhoAmIResponse Check is user logged in
   * @throws ApiError
   */
  public getAuthWhoAmI(): CancelablePromise<WhoAmIResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/who-am-i',
      errors: {
        401: `Unauthorized`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Register
   * @param requestBody Register body schema
   * @returns any Success register response
   * @throws ApiError
   */
  public registration(
    requestBody?: RegisterRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/registration',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        403: `Forbidden`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Register
   * @param requestBody Register body schema
   * @returns any Success register response
   * @throws ApiError
   */
  public registrationWarehouse(
    requestBody?: RegisterRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/warehouse/registration',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        403: `Forbidden`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
